import { Button, Stack, useTheme } from "@mui/material";
import React, { useState } from "react";
import Transaction from "./Transaction";
import Order from "./Order";
import { useGetOrderHistoryQuery } from "../../../../../Store/Slices/rtk";

export default function ProfileOrder() {
  const theme = useTheme();
  const orderHistory = useGetOrderHistoryQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const [tab, setTab] = useState("trans");
  return (
    <Stack>
      <Stack gap={"1rem"} direction={"row"} mb={"1rem"}>
        <Button
          onClick={() => setTab("trans")}
          sx={{
            height: {xs:"35px" , md:"50px"},
            width: "50%",
            color: "white",
            border: `2px solid ${theme.palette.primary.main}`,
          }}
          variant={tab == "trans" ? "contained" : "outlined"}
        >
          تراکنش ها
        </Button>
        <Button
          onClick={() => setTab("order")}
          sx={{
            height: {xs:"35px" , md:"50px"},
            width: "50%",
            color: "white",
            border: `2px solid ${theme.palette.primary.main}`,
          }}
          variant={tab == "order" ? "contained" : "outlined"}
        >
          سفارشات
        </Button>
      </Stack>

      {/* Content Tabs */}
      {tab == "trans" ? (
        <Transaction transActions={orderHistory?.data?.data?.orders} />
      ) : (
        <Order orders={orderHistory?.data?.data?.orders} />
      )}
    </Stack>
  );
}
